<div class="notice-overlay" *ngIf="current != null">
  <div class="notice-dialog">

    <div class="notice-pending" *ngIf="notices.length > 1">
      {{ 'NOTICE.PENDING' | translate }} {{ notices.length }}
    </div>

    <div class="notice-title" *ngIf="current.title">{{ current.title }}</div>

    <div class="notice-body" [innerHTML]="current.bodyHtml"></div>

    <div class="notice-questions" *ngIf="current.questions != null && current.questions.length > 0">
      <div class="notice-question" *ngFor="let question of current.questions">
        <div class="question-text">
          {{ question.questionText }}<span class="required" *ngIf="question.isRequired">*</span>
        </div>
        <div class="question-options">
          <button class="action option" [class.selected]="question.answer === true"
            (click)="setAnswer(question, true)">
            {{ question.yesLabel ? question.yesLabel : ('NOTICE.YES' | translate) }}
          </button>
          <button class="action option" [class.selected]="question.answer === false"
            (click)="setAnswer(question, false)">
            {{ question.noLabel ? question.noLabel : ('NOTICE.NO' | translate) }}
          </button>
        </div>
      </div>
    </div>

    <div class="notice-actions">
      <button class="action" [disabled]="!canConfirm()" (click)="confirm()">{{ 'NOTICE.ACCEPT' | translate }}</button>
    </div>
  </div>
</div>
